export default "__VITE_ASSET__BSIpNcWa__"